import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconBrandDokobit(props: IconProps) {
  return (
    <BaseIcon size={40} {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.2 11.932c0 6.22-5.62 9.668-11.378 9.668H1.8l.004-.778c1.425.006 2.192-.838 2.198-3.493V2.4h6.957c5.758 0 11.24 3.245 11.24 9.532Z"
        fill="url(#dokobit-icon)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.527 8.372c-.51 0-.924.064-1.29.19v-2.87a6.07 6.07 0 0 0-1.195-.095c-.382 0-.78.016-1.179.096v9.942c.877.46 2.087.73 3.345.73 2.74 0 4.476-1.538 4.476-4.091 0-2.554-1.784-3.902-4.157-3.902"
        fill="#FEFEFE"
      />
      <defs>
        <linearGradient
          id="dokobit-icon"
          x1="1.8"
          y1="21.6"
          x2="20.965"
          y2="1.237"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F03928" />
          <stop offset="1" stopColor="#FFDE00" />
        </linearGradient>
      </defs>
    </BaseIcon>
  );
}
